module.exports = __webpack_public_path__ + "img/logo-novonesis-dark.ec00564d.svg";